import arraySort from 'array-sort'
import clone from 'clone'
import moment from 'moment'

import { MISSION_STATUS_ENUM } from '../../../../shared/constants'
/**
 * Sort
 *
 * @param type
 * @param data
 * @returns {Array}
 */
export const sort = ({ data, sortBy }) => {
  let dataNew = clone(data)

  if (sortBy.columnName) {
    switch (sortBy.columnName) {
      case 'client':
        arraySort(dataNew, sortByText(sortBy, 'client'))
        break

      case 'type':
        arraySort(dataNew, sortByText(sortBy, 'type'))
        break

      case 'quantity':
        arraySort(dataNew, sortByQuantity(sortBy, 'quantity'))
        break

      case 'timeStart':
        arraySort(dataNew, sortByDate(sortBy, 'timeStart'))
        break

      case 'location':
        arraySort(dataNew, sortByText(sortBy, 'location'))
        break

      case 'street':
        arraySort(dataNew, sortByText(sortBy, 'street'))
        break

      default:
        arraySort(dataNew, sortBy.columnName, { reverse: sortBy.reverse })
    }
  }

  return dataNew
}

/**
 * Sort activities by name.
 *
 * @returns {function(*, *)}
 */
const sortByText = (sortBy, field) => {
  const reverse = sortBy.reverse
  let aText
  let bText

  return (a, b) => {
    switch (field) {
      case 'location':
        aText = a['location']['city']['name']
        bText = b['location']['city']['name']
        break
      case 'street':
        aText = a['location']['name']
        bText = b['location']['name']
        break
      case 'client':
        aText = a['client']['name']
        bText = b['client']['name']
        break
      case 'type':
        aText = a['type']['name']
        bText = b['type']['name']
        break
      default:
        aText = a['client']['name']
        bText = b['client']['name']
        break
    }

    return reverse ? bText.localeCompare(aText) : aText.localeCompare(bText)
  }
}

/**
 * Sort by date.
 *
 * @returns {function(*, *)}
 */
const sortByDate = (sortBy, field) => {
  const reverse = sortBy.reverse
  let aDate
  let bDate

  return (a, b) => {
    switch (field) {
      case 'timeStart':
        aDate = new Date(a['timeStart'])
        bDate = new Date(b['timeStart'])
        break
      default:
        aDate = new Date(a['timeStart'])
        bDate = new Date(b['timeStart'])
        break
    }
    return reverse ? bDate - aDate : aDate - bDate
  }
}

/**
 * Sort by quantity.
 *
 * @returns {function(*, *)}
 */
const sortByQuantity = (sortBy, field) => {
  const reverse = sortBy.reverse
  let quantityA
  let quantityB

  return (a, b) => {
    switch (field) {
      case 'quantity':
        quantityA = a.quantity
        quantityB = b.quantity
        break
      default:
        quantityA = a.quantity
        quantityB = b.quantity
        break
    }

    return reverse ? quantityB - quantityA : quantityA - quantityB
  }
}

export const getLastMissionDateLabel = missions => {
  let date = null
  missions.forEach(mission => {
    if (
      mission.status === MISSION_STATUS_ENUM.COMPLETED ||
      mission.status === MISSION_STATUS_ENUM.PAID
    ) {
      if (new Date(mission.dateTime) > new Date(date)) {
        date = mission.dateTime
      }
    }
  })
  return date ? moment(date).format('DD MMMM YYYY') : 'N/A'
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/util.js